import { lazy } from 'react';
export var CoursesPageAsync = lazy(function () { return import('./CoursesPage'); });
